export class BoxAiRequestDto {
  constructor(public request: string, public fileId: string) {}
}
